(function () {
    "use strict";

    angular.module("app").factory("commonServices", CommonServicesFactory);

    CommonServicesFactory.$inject = ["webApiServices", "notificationService", "loadingIndicatorService", "settingsService", "HabilUrlParser", "HabilNavigator", "commentsService"];
    function CommonServicesFactory(webApiServices, notificationService, loadingIndicatorService, settingsService, HabilUrlParser, HabilNavigator, commentsService) {
        return {
            Api: webApiServices,
            Notifications: notificationService,
            LoadingIndicator: loadingIndicatorService,
            Settings: settingsService,
            HabilUrlParser: HabilUrlParser,
            Navigator: HabilNavigator,
            Comments: commentsService
        };
    }
})();
